import { render } from "./PortraitItem.vue?vue&type=template&id=51436fca&scoped=true"
import script from "./PortraitItem.vue?vue&type=script&lang=js"
export * from "./PortraitItem.vue?vue&type=script&lang=js"

import "./PortraitItem.vue?vue&type=style&index=0&id=51436fca&lang=scss&scoped=true"

import exportComponent from "/root/Fnedu/build/build20250805.141732/dashboard/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51436fca"]])

export default __exports__